// @ts-nocheck
import Cookies from 'universal-cookie';

export const cookies = new Cookies();

export const parseCookie = (str = '') =>
	str
		.split(';')
		.map((v) => v.split('='))
		.reduce((acc, v) => {
			acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(
				v[1].trim(),
			);
			return acc;
		}, {});

export const getAccessToken = () => {
	if (document.cookie.length === 0) return null;
	const { auth } = parseCookie(document.cookie);
	return auth ? JSON.parse(auth).access_token : null;
};
